import { useAppSelector } from 'app/hooks';
import { DerivedDuctDefaults, deriveDefaultDucts } from 'utils/duct-defaults';

// Reactive wrapper around deriveDefaultDucts. Subscribing to projectSettings
// here also keeps consumers (e.g. the Fine-Tuning duct dropdowns, whose
// ProjectSetting reads the store imperatively) re-rendering when a setting
// changes.
export default function useDerivedDuctDefaults(): DerivedDuctDefaults {
  const structure = useAppSelector((state) => state.structure.structure);
  const existingSystems = useAppSelector(
    (state) => state.structure.existingSystems
  );
  const projectSettings = useAppSelector(
    (state) => state.project.projectSettings
  );

  return deriveDefaultDucts(structure, existingSystems, projectSettings);
}
